module.exports = __webpack_public_path__ + "media/images/mock-thumbs/product-3-d37a79f7770ababc012a45156b4dd07d.png";